/**
 * Mobile-first layout for execution dashboard (PRD: execution_account_prd).
 * Top: gradient bar with logo + logged user. Bottom nav: Tasks, History, Learn, Profile.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckSquare,
  History,
  BookOpen,
  User,
} from 'lucide-react';
import { APP_LOGO_SRC } from '../../constants/appLogo';
import './ExecutionMobileLayout.css';

const TAB_IDS = ['tasks', 'history', 'learn', 'profile'];

const TAB_ICONS = {
  tasks: CheckSquare,
  history: History,
  learn: BookOpen,
  profile: User,
};

export default function ExecutionMobileLayout({
  activeTab,
  onTabChange,
  children,
  hideNav = false,
  userName = '',
}) {
  const { t } = useTranslation('execution');

  const labels = {
    tasks: t('tabsTasks', 'Sarcini'),
    history: t('tabsHistory', 'Istoric'),
    learn: t('tabsLearn', 'Formare'),
    profile: t('tabsProfile', 'Profil'),
  };

  return (
    <div className="execution-mobile-layout">
      <header className="execution-top-bar">
        <img src={APP_LOGO_SRC} alt="ZeroPath" className="execution-top-bar-logo" />
        <span className="execution-top-bar-user">{userName || t('executionStaff', 'Personal execuție')}</span>
      </header>
      <main className="execution-mobile-main">
        {children}
      </main>
      {!hideNav && (
        <nav
          className="execution-bottom-nav"
          role="navigation"
          aria-label={t('mainNavigation', 'Main navigation')}
        >
          {TAB_IDS.map((id) => {
            const Icon = TAB_ICONS[id];
            const isActive = activeTab === id;
            return (
              <button
                key={id}
                type="button"
                className={`execution-nav-item ${isActive ? 'active' : ''}`}
                onClick={() => onTabChange(id)}
                aria-current={isActive ? 'page' : undefined}
                aria-label={labels[id]}
              >
                <span className="execution-nav-icon">
                  <Icon size={32} strokeWidth={2} />
                </span>
                <span className="execution-nav-label">{labels[id]}</span>
              </button>
            );
          })}
        </nav>
      )}
    </div>
  );
}
